import { useTranslation } from 'react-i18next';
import { Seo } from '../components/Seo';
import { LocalizedLink } from '../components/LocalizedLink';
import { blogPosts } from '../data/blog';

export function Blog() {
  const { t } = useTranslation();

  return (
    <>
      <Seo
        title="Technical Insights Blog | GyroNavi"
        description="Latest articles on inertial navigation technology, FOG selection, and MEMS vs FOG comparisons."
        path="/blog"
      />
      <section className="section">
        <p className="eyebrow">{t('blog:page.eyebrow')}</p>
        <h1 className="mt-2 text-4xl font-black text-ink">{t('blog:page.title')}</h1>
        <p className="mt-3 text-slate-600">{t('blog:page.subtitle')}</p>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {blogPosts.map((post) => (
            <LocalizedLink key={post.slug} to={`/blog/${post.slug}`} className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-panel">
              <div className="text-sm text-slate-500">{post.date}</div>
              <h2 className="mt-2 text-xl font-black text-ink">{post.title}</h2>
              <p className="mt-3 leading-7 text-slate-600">{post.excerpt}</p>
            </LocalizedLink>
          ))}
        </div>
      </section>
    </>
  );
}
